module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1p",
    attrs: {
      "id": "p0017-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_10",
      "id": "sn_10"
    }
  }, [_vm._v("DAY 10")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_10"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("REALLY")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("The serpent said to the woman, “Did God really say, ‘You must not eat from any tree in the garden’?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 3:1")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0017-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("icture a snake-oil peddler from the Old West. That special tonic of his could cure anything and everything that folks in the crowd were suffering from—guaranteed! Really!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And that word, "), _c('i', [_vm._v("really,")]), _vm._v(" could have—should have—been in the garden. “Did God "), _c('i', [_vm._v("really")]), _vm._v(" say "), _c('i', [_vm._v(". . .?” ")]), _vm._v("Can’t you hear the word pronounced, drawn out, dripping with disbelief? “"), _c('i', [_vm._v("Reaaaally")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The crafty serpent’s expression of disbelief continued, underlining God’s unreasonable rule: “You mean you can’t eat from "), _c('i', [_vm._v("any")]), _vm._v(" of these beautiful trees? You can’t eat "), _c('i', [_vm._v("any")]), _vm._v(" of this delicious-looking fruit?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Taking the bait, Eve agreed that God had been awfully strict with Adam and her. She clarified that they could eat from any and all trees except that tree in the middle—and that one they couldn’t even touch!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course the serpent didn’t correct Eve’s overstatement, for she was playing right into his hand. He even sweetened the deal: “Eat the fruit from that tree, and the effects will be amazing! You will be like God!” The snake’s snake-oil pitch was complete.")]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_vm._v("IF YOU’RE DOUBTING GOD’S GUIDELINES FOR LIFE, THAT MAY BE SATAN SPEAKING.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b708e1a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter13.vue
// module id = 99
// module chunks = 0